<template>
  <v-data-table
    :headers="headers"
    :items-per-page="15"
    :items="mappedMember"
    disable-sort
    hide-default-footer
    class="elevation-1">
    <template v-slot:[`item.more`]="{ item }">
      <a @click="seeMore(item)">view</a>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Tel', value: 'tel' },
        { text: 'Name', value: 'name' },
        { text: 'DOB', value: 'birthDate' },
        { text: 'Email', value: 'email' },
        { text: 'Spending', value: 'spending.total', align: 'center' },
        { text: 'Detail', value: 'more' }
      ]
    }
  },
  computed: {
    mappedMember () {
      return this.items.map((d) => ({
        name: `${d.firstName} ${d.lastName}`,
        ...d
      }))
    }
  },
  methods: {
    seeMore (item) {
      this.$router.push({ name: 'MemberDetail', params: { id: item.id } })
    }
  }
}
</script>
